<template>
    <el-dialog :visible.sync="visible" :title="申请记录" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-card shadow="never" class="aui-card--fill">
    <el-table  :data="dataList" border style="width: 100%;">
        <el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="applyAmount" label="借款金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="period" label="借款期限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="借款状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="applyDate" label="申请时间" header-align="center" align="center"></el-table-column>
    </el-table>
    </el-card>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        username: '',
        password: '',
        realName: '',
        gender: '',
        email: '',
        mobile: '',
        deptId: '',
        superUser: '',
        defaultVerificationCode: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      },
        dataList: []               // 数据列表
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`sys/appsysloanapply/getLoanList?appUserId=${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
          this.dataList = res.data
      }).catch(() => {})
    }
  }
}
</script>
